import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { RequireAuth } from '@/router/RequireAuth'
import LoginPage from '@/pages/LoginPage'
import QueuePage from '@/pages/QueuePage'
import TicketDetailPage from '@/pages/TicketDetailPage'
import NewTicketPage from '@/pages/NewTicketPage'
import AnalyticsPage from '@/pages/AnalyticsPage'
import SlaPoliciesPage from '@/pages/SlaPoliciesPage'
import CatalogProductsPage from '@/pages/admin/CatalogProductsPage'
import CatalogProductPage from '@/pages/admin/CatalogProductPage'
import CatalogClientsPage from '@/pages/admin/CatalogClientsPage'
import CatalogClientPage from '@/pages/admin/CatalogClientPage'
import AccessPage from '@/pages/admin/AccessPage'
import BoardsPage from '@/pages/BoardsPage'
import BoardPage from '@/pages/BoardPage'

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/queue" replace />} />
          <Route path="/queue" element={<QueuePage />} />
          <Route path="/tickets/new" element={<NewTicketPage />} />
          <Route path="/tickets/:id" element={<TicketDetailPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/admin/sla" element={<SlaPoliciesPage />} />
          <Route path="/admin/products" element={<CatalogProductsPage />} />
          <Route path="/admin/products/:id" element={<CatalogProductPage />} />
          <Route path="/admin/clients" element={<CatalogClientsPage />} />
          <Route path="/admin/clients/:id" element={<CatalogClientPage />} />
          <Route path="/admin/access" element={<AccessPage />} />
          <Route path="/boards" element={<BoardsPage />} />
          <Route path="/boards/:id" element={<BoardPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/queue" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
